import { render, staticRenderFns } from "./WBC.vue?vue&type=template&id=7617602a&scoped=true&"
import script from "./WBC.vue?vue&type=script&lang=js&"
export * from "./WBC.vue?vue&type=script&lang=js&"
import style0 from "./WBC.vue?vue&type=style&index=0&id=7617602a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617602a",
  null
  
)

export default component.exports